module.exports = __webpack_public_path__ + "static/background-330e4a74236d2ace8fac168c36a046bd.png";